import Flickity from 'flickity';
import 'flickity-fade';
// import 'flickity-imagesloaded';
// import 'flickity-as-nav-for';

function thumbNav (carousel, nav, flkty) {
	let btns = nav.querySelectorAll('button');
	if (!btns.length) return;
	// let utils = window.fizzyUIUtils;

	function clearSelected() {
		for (let btn of btns) {
			btn.removeAttribute('data-flkty-selected');
		}
	}

	function setSelectedFromIndex() {
		let btn = btns[flkty.selectedIndex];
		btn.setAttribute('data-flkty-selected', true);
	}

	setSelectedFromIndex();

	nav.addEventListener('click', function(event) {
		// let index = thumbs.indexOf(event.target);
		let btn = event.target.closest('button');
		if (!btn) return;
		clearSelected();
		btn.setAttribute('data-flkty-selected', true);
		let index = [...btns].indexOf(btn);
		flkty.select(index);
	});

	flkty.on('select', function() {
		clearSelected();
		setSelectedFromIndex();
	});
}

/* eslint-disable no-unused-vars, no-undef */
function resizeImages(carousel, flkty) {
	console.log('resizing');
	if (!carousel || !flkty) return;
	let images = carousel.querySelectorAll('img');
	if (!images.length) return;

	let screen = {
		small: null,
		medium: window.matchMedia('(min-width: 768px)'),
		large: window.matchMedia('(min-width: 992px)')
	};

	function setImageDims(height) {
		if (!height || isNaN(height)) {
			for (let img of images) {
				img.removeAttribute('style');
			}
			flkty.resize();
			return;
		}
		for (let img of images) {
			let w = img.width;
			let h = img.height;
			let width = w * height / h;
			img.style.width = width + 'px';
			img.style.height = height + 'px';
		}
		flkty.resize();
	}

	// media query handler function
	function mqHandler() {
		let size = null;
		for (let [scr, mq] of Object.entries(screen)) {
			if (!mq || mq.matches) size = scr;
		}
		console.log(size);
		switch (size) {
			case 'small':
				setImageDims(220);
				break;
			case 'medium':
				setImageDims(330);
				break;
			case 'large':
				setImageDims();
				break;
			default:
				setImageDims();
				break;
		}
	}

	// first event
	mqHandler();

	// add media query events
	for (let [scr, mq] of Object.entries(screen)) {
		if (mq) mq.addEventListener('change', mqHandler);
	}
}

( function() {
	let carousels = document.querySelectorAll('[data-flkty-type]')
	if (!carousels.length) return;

	for (let carousel of carousels) {
		let type = carousel.getAttribute('data-flkty-type');
		let options = {
			prevNextButtons: true,
			pageDots: true
		};
		switch (type) {
			case 'hero':
			case 'fade':
				options.fade = true;
				options.prevNextButtons = false;
				options.autoPlay = 4000;
				options.wrapAround = true;
				break;
			case 'inline':
				options.freeScroll = true;
				options.wrapAround = true;
				options.pageDots = false;
				options.imageLoaded = true;
				break;
			case 'scroll':
				options.pageDots = false;
				break;
		}
		console.log(options);
		if (options.pageDots) carousel.classList.add('has-dots-nav');
		if (options.prevNextButtons) carousel.classList.add('has-btns-nav');
		let flkty = new Flickity(carousel, options);
		if (type === 'inline') resizeImages(carousel, flkty);
		let id = carousel.id;
		if (!id) continue;
		let nav = document.querySelector('[data-flkty-nav-for="' + id + '"]');
		if (!nav) continue;
		thumbNav(carousel, nav, flkty);
	}
} )();
/* eslint-enable no-unused-vars, no-undef */


